import {
  belongsTo,
  hasMany,
  type AsyncBelongsTo,
  type AsyncHasMany,
} from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type CommentModel from './comment';
import type InitiativeModel from './initiative';
import type PersonModel from './person';
import TeamBasedModel from './team-based-model';
import type TeamModel from './team';
import type WeekModel from './week';
import type WorkstreamModel from './workstream';

export default class TfoModel extends TeamBasedModel {
  declare [Type]: 'tfo';
  @belongsTo('person', { inverse: 'tfos', async: true })
  declare author: AsyncBelongsTo<PersonModel>;
  @belongsTo('team', { inverse: 'tfos', async: true })
  declare team: AsyncBelongsTo<TeamModel>;
  @hasMany('comment', { async: true, inverse: 'tfo' })
  declare comments: AsyncHasMany<CommentModel>;
  @hasMany('person', { async: true, inverse: null })
  declare assignees: AsyncHasMany<PersonModel>;
  @belongsTo('workstream', { inverse: 'tfos', async: true })
  declare workstream: AsyncBelongsTo<WorkstreamModel>;
  @belongsTo('week', { inverse: 'tfos', async: true })
  declare week: AsyncBelongsTo<WeekModel>;
  @belongsTo('initiative', { inverse: 'tfos', async: true })
  declare initiative: AsyncBelongsTo<InitiativeModel>;
}
